/* Round 2 · ingredient slider. Chips, arrows, progress and swipe stay in sync. No libraries. */
(function(){
  var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(sec){
    if(sec.dataset.r2iOn)return; sec.dataset.r2iOn=1;
    var track=sec.querySelector('.r2i-track'); if(!track)return;
    var cards=[].slice.call(track.querySelectorAll('.r2i-card')), chips=[].slice.call(sec.querySelectorAll('.r2i-chip'));
    var row=sec.querySelector('.r2i-chips'), prev=sec.querySelector('.r2i-prev'), next=sec.querySelector('.r2i-next');
    var bar=sec.querySelector('.r2i-bar'), cnt=sec.querySelector('.r2i-count b'), n=cards.length, cur=-1, pin=-1, raf=0;
    if(!RM) sec.classList.add('mo');
    function padL(){return parseFloat(getComputedStyle(track).paddingLeft)||0}
    function maxS(){return track.scrollWidth-track.clientWidth}
    function set(i){
      if(i===cur)return; cur=i;
      cards.forEach(function(c,k){c.classList.toggle('on',k===i)});
      chips.forEach(function(c,k){c.setAttribute('aria-current',k===i?'true':'false')});
      if(cnt)cnt.textContent=i+1; if(bar)bar.style.width=((i+1)/n*100)+'%';
      if(prev)prev.disabled=i<=0; if(next)next.disabled=i>=n-1;
      var ch=chips[i];
      if(ch&&row&&row.scrollWidth>row.clientWidth+2){row.scrollTo({left:Math.max(0,ch.getBoundingClientRect().left-row.getBoundingClientRect().left+row.scrollLeft-(parseFloat(getComputedStyle(row).paddingLeft)||20)),behavior:RM?'auto':'smooth'})}
    }
    function near(){
      var x=track.scrollLeft+padL(), best=0, bd=1e9;
      cards.forEach(function(c,k){var d=Math.abs(c.offsetLeft-x); if(d<bd){bd=d;best=k}});
      if(track.scrollLeft>=maxS()-3 && pin<0 && window.innerWidth<750) best=n-1;
      return best;
    }
    function go(i){
      i=Math.max(0,Math.min(n-1,i)); pin=i; set(i);
      track.scrollTo({left:Math.min(cards[i].offsetLeft-padL(),maxS()),behavior:RM?'auto':'smooth'});
    }
    track.addEventListener('scroll',function(){ if(raf)return; raf=requestAnimationFrame(function(){raf=0; if(pin<0)set(near())}) },{passive:true});
    ['touchstart','wheel','pointerdown'].forEach(function(e){track.addEventListener(e,function(){pin=-1},{passive:true})});
    chips.forEach(function(c,k){c.addEventListener('click',function(){go(k)})});
    if(prev)prev.addEventListener('click',function(){go(cur-1)});
    if(next)next.addEventListener('click',function(){go(cur+1)});
    track.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'){e.preventDefault();go(cur+1)} else if(e.key==='ArrowLeft'){e.preventDefault();go(cur-1)} });
    set(0);
    if(!RM && 'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){sec.classList.add('in');io.disconnect()}})},{threshold:.2});
      io.observe(sec);
    } else sec.classList.add('in');
  }
  function all(){document.querySelectorAll('[data-r2i]').forEach(init)}
  if(document.readyState!=='loading')all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',all);
})();
